import { render, staticRenderFns } from "./lack_handle_type.vue?vue&type=template&id=637d81dd&scoped=true"
import script from "./lack_handle_type.vue?vue&type=script&lang=js"
export * from "./lack_handle_type.vue?vue&type=script&lang=js"
import style0 from "./lack_handle_type.vue?vue&type=style&index=0&id=637d81dd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "637d81dd",
  null
  
)

export default component.exports